import React, { Component, createElement } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import difference from 'lodash/difference'

import { Steps } from 'primereact/steps';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

import Header from '@components/Header';
import GeneralForm from '@components/Section/Forms/General';
import ComponentsLayout from '@components/Section/Forms/ComponentsLayout';
import VisibilityForm from '@components/Section/Forms/Visibility';
import PreviewForm from '@components/Section/Forms/Preview';
import LoadingAction from '@components/LoadingAction';
import JustificationModal from '@components/JustificationModal';


import { SET_VALUES_SECTION, CLEAR_VALUES_SECTION } from '@constants/actionType'
import { AuthorizedStatusSend, LANGUAGE_DEFAULT } from '@constants/general'

import { getSectionLayout, getDetailSection, extractInformationSection, updateSection, rejectSection, getSectionTree, updateStatusSection, deleteSection } from '@actions/sections';
import { setCatalogCurrentSectionTree } from '@actions/catalogs'
import { sendActionToBitacora  } from '@actions/bitacora';


import store from '@store'

class StepsEditSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      btnSubmitLoading: false,
      loadingAction: false,
      loadingPage: true,
      maxStep: 2,
      componentsSelectedOrigin: [],
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      transactionNameOpt: ''
    };
  }

  async componentDidMount() {
    const { languagesCatalog, i18n, t, history, getDetailSection, extractInformationSection } = this.props
    if (!history.location.state?.id) return history.push('/sections')
    if (history.location.state?.clearCache) {
      await store.dispatch({
        type: CLEAR_VALUES_SECTION,
      })
    }
    const response = await getDetailSection({id: history.location.state.id})
    if (!response?.status) {
      await extractInformationSection(response.data)
      this.setState({componentsSelectedOrigin:  this.props._componentsSelected })
      if (history.location.state?.isPending) this.setState({step: this.state.maxStep})
    }
    return this.setState({loadingPage: false})
  }

  nexStep = async (data) => {
    const { step } = this.state
    this.setState({ btnSubmitLoading: true });
    if (step === 0) await this.validateMaxStepEditComponents()
    // if (step ===  2) return this.editLayout()
    this.setState(prevState => ({maxStep: step + 1 > prevState.maxStep ? step + 1 : prevState.maxStep}))
    this.setState(prevState => ({step: prevState.step + 1}))
    this.setState({ btnSubmitLoading: false });
  }

  backStep = (data) => {
    this.setState({ btnSubmitLoading: true });
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  onConfirmReject = () => {
    const { t } = this.props
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('Rechazar Sección'),
        label: t('Justificacion de rechazo'),
        continueAction: ({justification}) => this.onReject(justification),
      },
    });
  }

  onReject = async (justification) => {
    const { updateStatusSection, t, history, _section } = this.props
    const response = updateStatusSection({id: _section.id, status: AuthorizedStatusSend.STATUS_REJECTED, justification})
    if(!response.status) {
      this.setState({transactionNameOpt: 'rechazoSeccion'})
      await this.sendCommentToBitacora(justification)
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/sections'),
        onHide: () => history.push('/sections')
      });
    }
  }

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  onHideModalJustification = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  editLayout = async ({isLanding = true, action = null, justification = ""}) => {
    const { history, t, updateSection, getSectionTree, setCatalogCurrentSectionTree } = this.props
    this.setState({ loadingAction: true, btnSubmitLoading: true });
    try {
      const response = await updateSection(isLanding)
      if (action) {
        await action()
      }
      if (!response.status) {
        if (!action) { // Se realiza bitacora solo para cuando edita cambios (no se incluye cuando es cambio de estatus)
         await this.sendCommentToBitacora(justification)
        }
        await getSectionTree()
        await setCatalogCurrentSectionTree()
        this.setState({ loadingAction: false, btnSubmitLoading: false });
  
        return confirmDialog({
          message: t('La operación se ha realizado de manera éxitosa'),
          header: t('Confirmación'),
          icon: 'pi pi-check-circle',
          acceptLabel: t('Continuar'),
          rejectClassName: 'hide-component',
          accept: () => history.push('/sections'),
          onHide: () => history.push('/sections')
        });
      }
      this.setState({ loadingAction: false, btnSubmitLoading: false });
    } catch (error) {
      console.log('error', error)
      this.setState({ loadingAction: false, btnSubmitLoading: false });
    }
  }

  sendCommentToBitacora = async (justification) => {
    const { _general, sendActionToBitacora, _id_original, getDetailSection } = this.props
    const { transactionNameOpt } = this.state
    let nameSection = ''
    if (_id_original) {
      const response = await getDetailSection({id: _id_original})
      if (!response?.status) nameSection = response.data.nombre[LANGUAGE_DEFAULT]
      else nameSection = _general[LANGUAGE_DEFAULT].titleSeccion
    } else {
      nameSection = _general[LANGUAGE_DEFAULT].titleSeccion
    }
    const dataBitacora = {
      transactionName: transactionNameOpt || 'Seccion',
      reason: `${nameSection} || ${justification}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  onUpdateSection = (isLanding, justification) => {
    this.setState({
      transactionNameOpt: 'actSeccion'
    }, () => {
      this.editLayout({isLanding, justification})
    })
  }

  saveAndSendAuthorized = (isLanding, justification) => {
    const { updateStatusSection, _section} = this.props
    this.setState({
      transactionNameOpt: 'envAutSeccion'
    }, () => {
      this.editLayout({isLanding, action: async () => {
        const response = await updateStatusSection({id: _section.id, status: AuthorizedStatusSend.STATUS_PENDING})
        if (!response.status) {
          await this.sendCommentToBitacora(justification)
        }
      }})
    })
  }
  
  saveAndAutorized = (isLanding, justification) => {
    const { updateStatusSection, _section} = this.props
    this.setState({
      transactionNameOpt: 'autSeccion'
    }, () => {
      this.editLayout({isLanding, action: async () => {
        const response = await updateStatusSection({id: _section.id, status: AuthorizedStatusSend.STATUS_AUTHORIZED, idOriginal: _section.id_original, selectedNavegationTree: _section.selectedNavegationTree})
        if (!response.status) {
          await this.sendCommentToBitacora(justification)
        }
      }})
    })
  }

  updateSectionFilter = (justification) => {
    this.setState({transactionNameOpt: 'actSeccion'}, () => {
      this.editLayout({isLanding: false, justification})
    })
  }

  updateSectionTypeDocument = (isLanding, justification) => {
    this.setState({transactionNameOpt: 'actSeccion'}, () => {
      this.editLayout({isLanding: true, justification})
    })
  }

  onConfirmDeleteVersion = () => {
    const { t, _section } = this.props
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('Confirmación'),
        description: t('¿Esta seguro que desea eliminar esta sección?'),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.deleteVersion(justification),
      },
    });
  }

  deleteVersion = async (justification) => {
    const { deleteSection, t, history, _section } = this.props
    const type = "physical"
    const response = deleteSection({id: _section.id, type, justification})
    if(!response.status) {
      this.setState({transactionNameOpt: 'elimVersionSeccion'})
      await this.sendCommentToBitacora(justification)
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/sections'),
        onHide: () => history.push('/sections')
      });
    }
  }

  validateOnchangeStep = (e) => {
    const { maxStep } = this.state
    if (e.index > maxStep) return true
    return this.setState({step: e.index}) 
  }

  validateMaxStepEditComponents = async () => {
    const { componentsSelectedOrigin } = this.state
    const { _componentsSelected } = this.props
    if (!componentsSelectedOrigin.length) this.setState({componentsSelectedOrigin: _componentsSelected})
    else {
      let differenceComponents = difference(_componentsSelected, componentsSelectedOrigin)
      if (differenceComponents.length) {
        this.setState({maxStep: 1, componentsSelectedOrigin: _componentsSelected})
      }
    }
  }

  render() {
    const { step, btnSubmitLoading, loadingPage, showModal, maxStep, showModalJustification } = this.state;
    const { t } = this.props;

    const steps = [
      { label: t("Datos generales"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Plantillas"), command: (event) => { this.validateOnchangeStep(event) } },
      // { label: t("Visibilidad"), command: (event) => { this.validateOnchangeStep(event) } },
      { label: t("Vista Previa"), command: (event) => { this.validateOnchangeStep(event) } }
    ]

    const footerModal = (
      <div>
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
      </div>
    );

    const stepsRender = () => {
      if (step === 0) {
        return (
          <GeneralForm
            success={this.nexStep}
            finishAction={this.updateSectionFilter}
            finishActionIsLanding={this.updateSectionTypeDocument}
            // authorize={() => this.editLayout(false)}
            btnSubmitLoading={btnSubmitLoading}
            isEdit

            authorize={this.saveAndAutorized}
            sendAuthorize={this.saveAndSendAuthorized}
            reject={this.onConfirmReject}
            deleteVersion={this.onConfirmDeleteVersion}

          />
        );
      }
      if (step === 1) {
        return (
          <ComponentsLayout
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            parentMaxStep={maxStep}
          />
        );
      }
      // if (step === 2) {
      //   return (
      //     <VisibilityForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      if (step === 2) {
        return (
          <PreviewForm
            success={this.onUpdateSection}
            // authorize={this.nexStep}
            reject={this.onConfirmReject}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
            isEdit

            authorize={this.saveAndAutorized}
            sendAuthorize={this.saveAndSendAuthorized}
            deleteVersion={this.onConfirmDeleteVersion}
          />
        );
      }
      return true;
    };

    if (loadingPage) return <LoadingAction/>
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t("Datos de la seccion")} linkText={t("Ir al listado")} to="/sections" />
          <div className="card">
            <div className="p-grid p-mb-2">
              <div className="p-col-12 p-my-1">
                <Steps model={steps} activeIndex={step} readOnly={false}/>
              </div>
            </div>
            
            {stepsRender()}
            {/* <button
              onClick={() => {
                this.setState({ step: step - 1 });
              }}
            >
              Click menos
            </button>
            <button
              onClick={() => {
                this.setState({ step: step + 1 });
              }}
            >
              Click mas
            </button> */}
          </div>
        </div>
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '75vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
        { this.state.loadingAction && <LoadingAction/> }
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          descriptionAlt={showModalJustification.descriptionAlt}
          label={showModalJustification.label}
          btnOkLabel={showModalJustification.btnOkLabel}
          onHidden={() => this.onHideModalJustification()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mainClass: state.section.mainClass,
  totalSteps: state.section.totalSteps,
  languagesCatalog: state.catalogs.languagesCatalog,


  _componentsAvailables: state.section.componentsAvailables,
  _componentsSelected: state.section.componentsSelected,
  _keysLenguages: state.catalogs.keysLanguageCatalog,
  _section: state.section,
  _general: state.section.general,
  _id_original: state.section.id_original,
});

const mapDispatchToProps = {
  getSectionLayout,
  getDetailSection,
  extractInformationSection,
  updateSection,
  rejectSection,
  getSectionTree,
  setCatalogCurrentSectionTree,
  updateStatusSection,
  deleteSection,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(StepsEditSection);
